<template>
  <div>
    <p v-if="options.length" class="gp-option-list-title">{{ title }}</p>
    <ul class="">
      <li
        class="g-flex g-flex-col g-mb-8 g-cursor-pointer"
        :class="{ 'g-opacity-75': !isSelected(option) }"
        v-for="option of options"
        :key="option.position"
        @click="selectOption(option)"
      >
        <div class="g-flex g-items-center g-w-full g-bg-white g-rounded-t g-overflow-hidden g-border g-border-grey-200">
          <div class="g-px-4 g-py-3 g-mr-3 g-bg-grey-300 g-text-white" :class="{ '!g-bg-green-500': isSelected(option) }">
            <gp-icon
              size="lg"
              :icon="['fas', 'check-circle']"
              :style="{
                cursor: 'pointer',
                transform: 'scale(1.4)',
              }"
            />
          </div>
          <div class="g-font-bold">{{ option.name }}</div>
          <div
            class="g-flex g-self-stretch g-justify-center g-items-center g-ml-auto g-min-w-[160px] g-bg-green-500 g-text-white g-uppercase g-font-bold"
            v-if="!disableAlternativeHeaders || option.position === 1"
            :class="{ '!g-bg-orange-500': option.position === 2, '!g-bg-grey-500': option.position === 3 }"
          >
            {{ option.type }}
          </div>
        </div>

        <div class="g-w-full g-rounded-b g-px-4 g-py-4 g-bg-white g-border g-border-t-0 g-border-grey-200">
            <slot :option="option"></slot>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OptionList",

  props: ["options", "title", "module", "stateKey", "disableAlternativeHeaders"],

  methods: {
    selectOption(option) {
      this.$emit("select", option);
    },

    isSelected(option) {
      let selection = this.$store.state[this.module][this.stateKey || "selection"];
      if (!selection) return false;

      return selection.name === option.name && selection.type === option.type;
    },
  },
};
</script>

<style></style>
